<div class="fixed inset-0 z-[99] flex items-center justify-center bg-black/70 backdrop-blur-sm transition-opacity"
    (click)="onClose()">

    <div class="relative w-[90%] max-w-sm bg-white rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col items-center p-0 animate-fade-in-up"
        (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="w-full flex justify-between items-center p-4.5 border-b border-slate-100 bg-slate-50 text-left">
            <h3 class="text-sm font-black text-slate-800 flex items-center gap-1.5 leading-none">
                <img src="icons/qr_code_scanner_orange.svg" />
                {{ currentLanguage === 'TH' ? 'สแกน QR ที่เครื่องชาร์จ' : 'Scan Charger QR' }}
            </h3>
            <button (click)="onClose()"
                class="w-7 h-7 flex items-center justify-center bg-slate-200 hover:bg-slate-300 text-slate-600 rounded-full transition-colors focus:outline-none border-none cursor-pointer">
                <img src="icons/close_black.svg" class="w-5 h-5" />
            </button>
        </div>

        <div *ngIf="!isScanningWeb" class="w-full p-6 flex flex-col items-center select-none">

            <!--------------------- Step 1: Scan (Initial Guide) ----------------------->
            <ng-container *ngIf="step === 'scan'">
                <div class="text-center mb-5">
                    <p class="text-xs text-slate-500 font-bold leading-relaxed">
                        {{ currentLanguage === 'TH' ? "กรุณาสแกน QR Code ที่ตู้ชาร์จเพื่อสั่งเริ่มการชาร์จรถ" :
                        "Scan the QR Code on the charging station to start service."}}
                    </p>
                </div>

                <!-- High-tech Finder Scan Box Mockup -->
                <div
                    class="relative w-48 h-48 mx-auto mb-6 flex items-center justify-center bg-slate-50 rounded-[2rem] border border-slate-100 shadow-inner overflow-hidden group">
                    <img src="images/Ev-charger/QR-code.jpg" alt="Scan QR Example"
                        class="w-28 h-28 object-contain mix-blend-multiply opacity-80 transition-transform duration-500 group-hover:scale-105"
                        onerror="this.src='https://cdn-icons-png.flaticon.com/512/3409/3409559.png'" />

                    <!-- Scanner Laser line -->
                    <div
                        class="absolute left-6 right-6 h-0.5 bg-gradient-to-r from-transparent via-amber-400 to-transparent top-1/2 -translate-y-1/2 animate-pulse z-10">
                    </div>

                    <!-- Finder Corner brackets -->
                    <div
                        class="absolute inset-5 border border-dashed border-amber-400/40 rounded-2xl pointer-events-none">
                    </div>

                    <!-- Example Tag Badge -->
                    <div
                        class="absolute top-2.5 right-2.5 px-2 py-0.5 bg-slate-100/90 backdrop-blur-sm rounded-md border border-slate-200 shadow-sm z-10">
                        <p class="text-[8px] font-black text-slate-400 uppercase tracking-wide leading-none">
                            {{ currentLanguage === 'TH' ? 'ตัวอย่าง' : 'EXAMPLE' }}
                        </p>
                    </div>
                </div>

                <!-- QR Scanner output logs (dev preview) -->
                <div *ngIf="qrCodeResult"
                    class="w-full text-center mb-4 p-2 bg-red-50 rounded-xl border border-red-100/35">
                    <p class="text-[10px] text-red-500 font-bold break-all leading-relaxed">
                        {{ currentLanguage === 'TH' ? 'อ่านรหัสเครื่องได้:' : 'Read station ID:' }} <span
                            class="font-mono font-black">{{ qrCodeResult }}</span>
                    </p>
                </div>

                <!-- SCAN Action Trigger -->
                <button (click)="onScanQr()" [disabled]="isOpeningCamera"
                    [class.opacity-60]="isOpeningCamera"
                    class="w-full py-3.5 bg-amber-400 hover:bg-amber-500 text-slate-800 text-sm font-black rounded-2xl shadow-sm active:scale-95 transition-all flex items-center justify-center gap-2 border-none outline-none cursor-pointer">
                    <img src="icons/qr_code_scanner_black.svg" />
                    <span>{{ currentLanguage === 'TH' ? 'เปิดกล้องสแกน' : 'Open Camera' }}</span>
                </button>

                <button *ngIf="canUseLineScanner" (click)="onScanWithLine()" [disabled]="isOpeningCamera"
                    class="w-full mt-2.5 py-2.5 bg-transparent text-slate-500 text-xs font-bold rounded-2xl border border-slate-200 active:scale-95 transition-all cursor-pointer">
                    {{ currentLanguage === 'TH' ? 'เปิดกล้องไม่ได้? ใช้สแกนเนอร์ของ LINE' : "Camera not working? Use LINE scanner" }}
                </button>
            </ng-container>

            <!--------------------- Step 2: Loading Validation ---------------------->
            <ng-container *ngIf="step === 'selectBox' && isLoadingValidation">
                <div class="flex flex-col items-center justify-center py-10">
                    <div class="animate-spin rounded-full h-9 w-9 border-b-2 border-amber-400 mb-4"></div>
                    <p class="text-xs text-slate-500 font-bold">{{ currentLanguage === 'TH'
                        ? 'กำลังตรวจสอบข้อมูลหัวชาร์จ...'
                        : 'Verifying charger status...' }}</p>
                </div>
            </ng-container>

            <!--------------------- Step 3: Vehicle Selection --------------------->
            <ng-container *ngIf="step === 'select'">
                <!-- Station Details Grid -->
                <div class="w-full space-y-2.5 mb-4 text-left">
                    <!-- Location -->
                    <div>
                        <span class="text-[10px] font-black text-slate-400 block leading-none">{{ currentLanguage ===
                            'TH' ? 'สถานที่ตั้ง' : 'Site Location' }}</span>
                        <div
                            class="flex items-center gap-2 p-3 bg-slate-50 rounded-2xl border border-slate-100/50 mt-1 text-xs text-slate-700 font-bold leading-none">
                            <img src="icons/distance_slate_dark.svg" />
                            <span class="truncate">{{ location }}</span>
                        </div>
                    </div>

                    <!-- Charging station ID -->
                    <div>
                        <span class="text-[10px] font-black text-slate-400 block leading-none">{{ currentLanguage ===
                            'TH' ? 'หมายเลขหัวชาร์จ' : 'Charger Box Number' }}</span>
                        <div
                            class="flex items-center gap-2 p-3 bg-slate-50 rounded-2xl border border-slate-100/50 mt-1 text-xs text-slate-700 font-mono font-bold leading-none">
                            <img src="icons/ev_station_slate_dark.svg" />
                            <span class="truncate">{{ station }}</span>
                        </div>
                    </div>
                </div>

                <!-- Select vehicle block header -->
                <div class="flex items-center justify-between w-full mb-2">
                    <div class="text-left">
                        <span class="text-xs font-black text-slate-800 block leading-none">{{ currentLanguage === 'TH' ?
                            "ระบุทะเบียนรถ" : "Select Vehicle" }}</span>
                        <span class="text-[9px] text-slate-400 font-bold block mt-0.5 leading-none">{{ currentLanguage
                            === 'TH' ? "เลือกรถยนต์ที่จะชาร์จ" : "Choose vehicle to charge" }}</span>
                    </div>
                    <button (click)="createVehicle()"
                        class="px-2.5 py-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-600 text-[10px] font-black rounded-xl border-none transition-all active:scale-95 cursor-pointer">
                        {{ currentLanguage === 'TH' ? '+ เพิ่มรถยนต์' : '+ Add Vehicle' }}
                    </button>
                </div>

                <!-- Scrollable vehicles list -->
                <div
                    class="w-full max-h-48 overflow-y-auto space-y-2 mb-4 pr-1 custom-scrollbar text-left border border-slate-100/50 rounded-2xl p-1 bg-slate-50/50">
                    <div *ngFor="let vehicle of userVehicles" (click)="selectVehicle(vehicle)"
                        class="p-3 w-full rounded-2xl flex justify-between items-center cursor-pointer transition-all border"
                        [ngClass]="selectedVehicle?.id === vehicle.id ? 'bg-amber-500/[0.04] border-amber-400' : 'bg-white border-slate-100 hover:bg-slate-50'">

                        <div class="flex items-center gap-3 min-w-0">
                            <img class="shrink-0 " src="icons/directions_car_slate_dark.svg" />
                            <div class="min-w-0">
                                <p class="text-xs font-black text-slate-700 block leading-tight truncate">{{
                                    vehicle.name }}</p>
                                <p class="text-[9px] text-slate-400 font-bold block mt-0.5 leading-none">{{
                                    vehicle.province }}</p>
                            </div>
                        </div>

                        <!-- Checkmark Indicator -->
                        <img *ngIf="selectedVehicle?.id === vehicle.id" src="icons/check_circle_orange.svg" />
                    </div>
                </div>

                <!-- Warning Notice -->
                <div
                    class="w-full text-left bg-rose-500/[0.03] border border-rose-100/30 rounded-2xl p-3 mb-4 flex gap-2 items-start">
                    <img src="icons/info_red.svg" />
                    <p class="text-[9px] font-bold text-rose-600 leading-snug">
                        *{{ currentLanguage === 'TH'
                        ?'หลังทำการกดยืนยันแล้ว กรุณาเริ่มเสียบสายชาร์จรถภายใน 10 นาที'
                        : 'Once confirmed, please plug-in and start charging the vehicle within 10 minutes.' }}
                    </p>
                </div>

                <!-- Action button row -->
                <div class="w-full flex gap-3">
                    <button (click)="resetState()"
                        class="flex-1 py-3 bg-slate-100 text-slate-500 font-bold rounded-2xl border-none outline-none cursor-pointer text-xs active:scale-95 transition-all">
                        {{ currentLanguage === 'TH' ? 'ย้อนกลับ' : 'Back' }}
                    </button>
                    <button (click)="confirmSelection()"
                        class="flex-1 py-3 font-black rounded-2xl shadow-sm text-xs border-none outline-none cursor-pointer active:scale-95 transition-all"
                        [ngClass]="selectedVehicle ? 'bg-amber-400 text-slate-800 hover:bg-amber-500' : 'bg-slate-100 text-slate-400 cursor-not-allowed'"
                        [disabled]="!selectedVehicle">
                        {{ currentLanguage === 'TH' ? 'ยืนยันสั่งชาร์จ' : 'Confirm' }}
                    </button>
                </div>
            </ng-container>

        </div>

        <!--------------------- Scanner View (isScanningWeb camera view) ---------------------->
        <div *ngIf="isScanningWeb" class="w-full h-[360px] bg-black relative flex flex-col items-center justify-center">

            <!-- Camera Loading indicator -->
            <div *ngIf="isLoadingCamera" class="absolute z-10 text-white flex flex-col items-center select-none">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-white mb-3"></div>
                <p class="text-xs font-bold text-slate-300">กำลังเชื่อมต่อกล้อง...</p>
            </div>

            <!-- Lens picker -->
            <div *ngIf="lenses.length > 1 && !isLoadingCamera"
                class="absolute top-3 left-0 right-0 z-30 flex justify-center px-3">
                <div class="flex gap-1 p-1 rounded-full bg-black/55 backdrop-blur-md border border-white/15 max-w-full overflow-x-auto">
                    <button *ngFor="let lens of lenses" type="button" (click)="selectLens(lens)"
                        class="shrink-0 px-3 h-8 rounded-full text-[11px] font-black border-none outline-none cursor-pointer transition-colors whitespace-nowrap"
                        [ngClass]="lens.device.deviceId === currentDevice?.deviceId ? 'bg-amber-400 text-slate-900' : 'bg-transparent text-white/85'">
                        {{ lensLabel(lens) }}
                    </button>
                </div>
            </div>

            <zxing-scanner #scanner [formats]="allowedFormats" [tryHarder]="true"
                (camerasFound)="onCamerasFound($event)" (camerasNotFound)="onCamerasNotFound()"
                (permissionResponse)="onPermissionResponse($event)" (autostarted)="onAutostarted()"
                (scanSuccess)="onCodeResult($event)" [previewFitMode]="'cover'">
            </zxing-scanner>

            <!-- Focus Target box -->
            <div
                class="absolute inset-0 border-[45px] border-black/50 pointer-events-none flex items-center justify-center">
                <div class="w-48 h-48 border-2 border-amber-400 rounded-3xl relative">
                    <div class="absolute inset-0 border border-white/20 rounded-2xl"></div>
                </div>
            </div>

            <p *ngIf="!isLoadingCamera"
                class="absolute bottom-[76px] left-0 right-0 z-20 text-center text-[11px] font-bold text-white/90 px-6 m-0 pointer-events-none">
                {{ currentLanguage === 'TH' ? 'เล็ง QR ที่ตู้ชาร์จให้อยู่ในกรอบ' : 'Align the charger QR inside the frame' }}
            </p>

            <!-- Cancel scan button -->
            <button (click)="isScanningWeb = false"
                class="absolute bottom-6 bg-white/20 hover:bg-white/30 backdrop-blur-md border border-white/30 text-white px-6 py-2.5 rounded-full text-xs font-black shadow-lg active:scale-95 transition-transform z-20 cursor-pointer">
                Cancel
            </button>
        </div>

    </div>
</div>